<template lang="pug">
    .component-card-5
        .row
            .columns.shrink.align-self-middle(v-if="showBullets")
                slot(name="actionBullets")
            .columns
                .row
                    .columns.n1.align-self-middle
                        slot(name="n1")
                    .columns.n2.align-self-middle
                        slot(name="n2")
                    .columns.n3.align-self-middle
                        slot(name="n3")
                    .columns.n4.align-self-middle
                        slot(name="n4")
                    .columns.n5.align-self-middle
                        slot(name="n5")
            .columns.shrink.align-self-middle(v-if="showAction")
                slot(name="actionPage")
</template>
<script type="text/babel">
    export default{
        name: "Card5",
        components: {
        },
        data(){
            return {}
        },
        created() {
        },
        methods: {
            actionClicked(){
                this.$emit('actionClicked')
            },
            bulletsClicked(){
                this.$emit('bulletsClicked')
            }
        },
        computed: {},
        props: ['showBullets', 'showAction']
    }
</script>

<style lang="sass" rel="stylesheet/sass">
    .action
        cursor: pointer
</style>


// WEBPACK FOOTER //
// Card5.vue?c6f1bde4